import { fieldMixin } from '@/mixins';

export default {
	name: 'cs-field-input',
	mixins: [fieldMixin],
};
